import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const PANEL_PARAM = 'notifications';
const PANEL_VALUE = 'open';

export const useNotificationsPanel = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isOpen = searchParams.get(PANEL_PARAM) === PANEL_VALUE;

  const open = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set(PANEL_PARAM, PANEL_VALUE);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  const close = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(PANEL_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  const toggle = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (next.get(PANEL_PARAM) === PANEL_VALUE) next.delete(PANEL_PARAM);
        else next.set(PANEL_PARAM, PANEL_VALUE);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return { isOpen, open, close, toggle };
};
